export enum OccurrenceTypeEnum {
  PREVENTIVE = 'P',
  CORRECTIVE = 'C',
  ASSISTANCE = 'A',
  WINCH = 'W',
  IN_DEALERSHIP = 'D',
}

export enum OccurrenceTypeLabelEnum {
  P = 'Preventiva',
  C = 'Corretiva',
  PC = 'Preventiva e Corretiva',
  A = 'Socorro',
  W = 'Guincho',
  D = 'Na Concessionária',
  CL = 'Sinistro',
}